import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'
import * as ordersConstant from './constants'
import * as ordersAction from './actions'
import { transfersFromCached } from '../../lib/common'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return response.data;
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    ordersConstant.PROCESS_ORDERS_LIST_API,
    formData
  )

  return handleRequest(request);
}

function processOrdersListNvRequestApi(formData) {
  const request = axiosApi().post(
    ordersConstant.PROCESS_ORDERS_LIST_NV_API,
    formData
  )

  return handleRequest(request);
}

function* processOrdersListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    yield put(ordersAction.setIsLoading(true));
    const results = yield call(listRequestApi, formData)
    const data = JSON.parse(results.data)
    // dispatch the action with our widgets!
    yield put(ordersAction.processOrdersListSuccess(data))

  } catch (error) {
    yield put(ordersAction.processOrdersListError(error))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}

function* processOrderListNvFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(processOrdersListNvRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(ordersAction.processOrdersListNvSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data);
    }
  } catch (error) {
    yield put(ordersAction.processOrdersListNvError(error))
  }
}

function* processOrderCreateFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      ordersConstant.PROCESS_ORDERS_CREATE_ORDER_API,
      payload
    )
    yield put(ordersAction.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(ordersAction.setProcessError(message))
    } else {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}

function* processOrderDeleteFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      ordersConstant.PROCESS_ORDERS_DELETE_ORDER_API,
      payload
    )
    yield put(ordersAction.setIsLoading(true));
    const { code, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(ordersAction.setProcessError(message))
    } else {
      yield call(callback)
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}
function* processOrderConfirmFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      ordersConstant.PROCESS_ORDERS_CONFIRM_API,
      payload
    )
    yield put(ordersAction.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(ordersAction.setProcessError(message))
    } else {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}
function* loadOrderExport({ payload, callback }) {
  try {
    const url = `${ordersConstant.PROCESS_ORDERS_LOAD_ORDER_EXPORT_API}/${payload.donXuatId}`;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    yield put(ordersAction.setIsLoading(true));
    const result = yield call(handleFileRequest, request);
    if (callback) {
      yield call(callback, result)
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}
function* loadOrderExcel({ payload, callback }) {
  try {
    const url = ordersConstant.PROCESS_ORDERS_LOAD_ORDER_XLS_API + "?maDonXuat=" + payload.maDonXuat + "&startDate=" + payload.startDate + "&endDate=" + payload.endDate + "&qrCode=" + payload.qrCode + "&trangThai=" + payload.trangThai + "&isXuatThieu=" + payload.isXuatThieu;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    yield put(ordersAction.setIsLoading(true));
    const result = yield call(handleFileRequest, request);
    if (callback) {
      yield call(callback, result)
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}
function* loadOrderDetailsFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      ordersConstant.PROCESS_ORDERS_LOAD_ORDER_DETAILS_API, payload
    )
    yield put(ordersAction.setIsLoading(true));
    const response = yield call(handleRequest, request);
    if (!response) {
      yield put(ordersAction.setProcessError("Lỗi lấy thông tin đơn hàng"))
    }
    const { code, message, data } = response
    if (code != 200) {
      yield put(ordersAction.setProcessError(message))
      return
    }
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}

function* processOrderCheckedListFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      ordersConstant.PROCESS_ORDERS_CHECKED_LIST_API,
      payload
    )
    yield put(ordersAction.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(ordersAction.setProcessError(message))
    } else {
      yield call(callback, data || {})
    }
  } catch (error) {
    yield put(ordersAction.setProcessError(error.toString()))
  } finally {
    yield put(ordersAction.setIsLoading(false));
  }
}


function* processOrdersWatcher() {
  yield takeLatest(ordersConstant.PROCESS_ORDERS_LIST_NV_REQUESTING, processOrderListNvFlow)
  yield takeEvery(ordersConstant.PROCESS_ORDERS_LIST_REQUESTING, processOrdersListRequestFlow)
  yield takeLatest(ordersConstant.PROCESS_ORDERS_CREATE_ORDER_REQUESTING, processOrderCreateFlow)
  yield takeLatest(ordersConstant.PROCESS_ORDERS_DELETE_ORDER, processOrderDeleteFlow)
  yield takeLatest(ordersConstant.PROCESS_ORDERS_LOAD_ORDER_EXPORT, loadOrderExport)
  yield takeLatest(ordersConstant.PROCESS_ORDERS_LOAD_ORDER_DETAILS, loadOrderDetailsFlow)
  yield takeLatest(ordersConstant.PROCESS_ORDERS_CHECKED_LIST_REQUESTING, processOrderCheckedListFlow)
  yield takeLatest(ordersConstant.PROCESS_ORDERS_CONFIRM_REQUESTING, processOrderConfirmFlow)
  yield takeEvery(ordersConstant.PROCESS_ORDERS_LOAD_ORDER_EXCEL, loadOrderExcel)
}

export default processOrdersWatcher



// WEBPACK FOOTER //
// ./src/views/ProcessOrders/sagas.js